const getCoords = (coords) => {
  if (coords.lat && coords.long) {
    const { lat, long } = coords;
    return { lat, long };
  }
  // ny
  return {
    lat: 40.7643304,
    long: -73.9772046,
  };
};

const initHeightCheck = () => {
  let appHeight = 0;

  const sendHeight = () => {
    if (appHeight !== document.body.offsetHeight) {
      appHeight = document.body.offsetHeight;
      window.parent.postMessage({
        event: 'resyHeightChanged',
        value: appHeight,
      }, '*');
    }
  };

  const heightCheck = () => {
    if (typeof window.requestAnimationFrame === 'undefined') {
      window.setTimeout(() => {
        sendHeight();
        heightCheck();
      }, 30);
    } else {
      window.requestAnimationFrame(() => {
        sendHeight();
        heightCheck();
      });
    }
  };

  heightCheck();
};

export {
  getCoords,
  initHeightCheck,
};
